import * as React from 'react';
import { Button } from '@cian/ui-kit';
import { Header4 } from '@cian/ui-kit/typography';

import * as styles from './styles.css';

export interface ILayoutsEntryProps {
  infoText: string;
  icon: React.ReactNode;
  onClick(event: React.MouseEvent<HTMLElement>): void;
}

export function LayoutsEntry({ infoText, icon, onClick }: ILayoutsEntryProps) {
  return (
    <div className={styles['container']}>
      {icon}
      <div className={styles['text']}>
        <Header4>{infoText}</Header4>
      </div>
      <Button theme="fill_secondary" size={'XS'} onClick={onClick}>
        Смотреть планировки
      </Button>
    </div>
  );
}
